import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, Award, ShieldCheck, TrendingUp, Heart } from "lucide-react";

const VALUES = [
  {
    icon: Lightbulb,
    title: "Innovación Social",
    text: "Buscamos constantemente nuevas metodologías didácticas y tecnologías de vanguardia para adaptar nuestras capacitaciones laborales a las capacidades individuales de cada participante.",
    image:
      "https://customer-assets.emergentagent.com/job_comision-empresarial/artifacts/3k2r6ii8_innovacion-social.webp",
  },
  {
    icon: Award,
    title: "Excelencia Inclusiva",
    text: "Nos comprometemos a que cada proyecto de orientación, curso de productividad y consultoría técnica refleje los más altos estándares de calidad del sector privado.",
    image:
      "https://customer-assets.emergentagent.com/job_comision-empresarial/artifacts/6aho5s1p_excelencia-inclusiva.webp",
  },
  {
    icon: ShieldCheck,
    title: "Integridad y Ética",
    text: "Actuamos con total transparencia y responsabilidad, honrando la confianza de las empresas aliadas y asegurando un trato digno y justo para todos nuestros beneficiarios.",
    image:
      "https://customer-assets.emergentagent.com/job_comision-empresarial/artifacts/2ni3cna9_integridad-etica.webp",
  },
  {
    icon: TrendingUp,
    title: "Desarrollo Continuo",
    text: "Impulsamos el aprendizaje constante en nuestro equipo y la actualización de nuestras investigaciones para mantenernos a la vanguardia de las ciencias sociales y humanidades.",
    image:
      "https://customer-assets.emergentagent.com/job_comision-empresarial/artifacts/h0jtvqgv_desarrollo-continuo.webp",
  },
  {
    icon: Heart,
    title: "Responsabilidad Social",
    text: "Orientamos cada una de nuestras acciones al bienestar comunitario, asegurando que la formación laboral se traduzca en una mejora real de la calidad de vida humana.",
    image:
      "https://customer-assets.emergentagent.com/job_comision-empresarial/artifacts/7gzpwuen_responsabilidad-social.webp",
  },
];

export const Values = () => {
  return (
    <section
      id="valores"
      data-testid="values-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="container-page">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.25em] text-[#055794] font-semibold mb-5">
              Nuestros valores
            </p>
            <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#022140] tracking-tight leading-[1.05] text-balance">
              Los principios que guían cada decisión.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-[17px] text-[#7F7F7F] leading-relaxed">
              Cinco valores que definen nuestra cultura, nuestra forma de
              trabajar y la promesa que hacemos a cada uno de los clientes que
              eligen confiar en nosotros.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {VALUES.map((v, i) => {
            const Icon = v.icon;
            const isLast = i === VALUES.length - 1;
            return (
              <motion.article
                key={v.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                data-testid={`value-card-${v.title.toLowerCase().replace(/\s+/g, "-")}`}
                className={`group relative overflow-hidden rounded-2xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-20px_rgba(2,33,64,0.25)] hover:border-[#72B3E4] ${
                  isLast ? "sm:col-span-2 lg:col-span-1" : ""
                }`}
              >
                <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                  <img
                    src={v.image}
                    alt={v.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    data-testid={`value-image-${i}`}
                  />
                  <div
                    aria-hidden
                    className="absolute inset-0 bg-gradient-to-t from-[#022140]/55 via-[#022140]/10 to-transparent"
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center justify-center h-11 w-11 rounded-xl bg-white text-[#055794] shadow-lg group-hover:bg-[#022140] group-hover:text-[#72B3E4] transition-colors">
                    <Icon size={20} />
                  </span>
                  <span className="absolute bottom-4 right-4 text-white/95 text-xs font-semibold uppercase tracking-[0.22em] flex items-center gap-2">
                    <span className="h-px w-6 bg-white/70" />
                    0{i + 1}
                  </span>
                </div>
                <div className="p-7">
                  <h3 className="font-heading text-2xl font-bold text-[#022140] mb-3">
                    {v.title}
                  </h3>
                  <p className="text-[15px] text-[#7F7F7F] leading-relaxed">
                    {v.text}
                  </p>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
